import { Calendar, Fuel, Palette, Settings2, Tag, Users } from 'lucide-preact';
import type { LucideIcon } from 'lucide-preact';

/**
 * 146 (US1, FR-003): icon-first spec rows instead of a plain label/value grid — the single
 * highest-scored "reads as modern, not a spec sheet" pattern the feature's own research found.
 *
 * 147: `color`/`category` added — both were already public on the wire and simply never
 * rendered (same gap shape as 146's own operating-hours/min-rental find). Conditional like the
 * other optional specs: a car with neither renders neither, never a placeholder.
 */
export const SPEC_ICONS: Record<
  'transmission' | 'fuel' | 'seats' | 'year' | 'color' | 'category',
  LucideIcon
> = {
  transmission: Settings2,
  fuel: Fuel,
  seats: Users,
  year: Calendar,
  color: Palette,
  category: Tag,
};

/**
 * 146 (US3, FR-008/FR-009): static, platform-wide "Good to know" content — identical on every
 * car's page, describing real, already-shipped platform rules (never per-car/per-supplier
 * policy). Identity verification: enforced at booking creation and again before pickup
 * (backend/src/modules/bookings/routes.ts). Cancellation/extension: features 130 (paid-booking
 * cancel guard) and 142/144/145 (extension pricing + resumable payment + platform fee) this
 * session shipped the actual behavior being described here — this card explains it, it does not
 * invent it.
 */
export const GOOD_TO_KNOW_ITEMS: Array<{ heading: string; body: string }> = [
  {
    heading: 'Identity verification required',
    body: 'You’ll need an approved identity check before you can pick up any car. If you haven’t completed one yet, start it early — approval isn’t instant.',
  },
  {
    heading: 'Cancellations and changes',
    body: 'You can cancel a booking any time before it’s paid for at no cost. Need more time once you’re already renting? You can extend your booking from the app — the extra time is priced and charged the same way as your original booking.',
  },
];
